import React from 'react'

import IconAccordionItem from './IconAccordionItem'
import { AccordionType } from '@contracts/acf/accordion'

import * as styles from './IconAccordion.module.scss'

type Props = {
	data: AccordionType
}

const IconAccordion: React.FC<Props> = ({ data }) => {
	// State
	const [accordionState, setAccordionState] = React.useState(
		data.accordions.reduce((acc: { [i: number]: boolean }, item, i) => {
			acc[i] = i === 0

			return acc
		}, {})
	)

	const handleSetActive = (index: number) => {
		// Handle the click event for the accordion item, close all items and open the clicked one.
		const newState = Object.keys(accordionState).reduce((acc: { [i: number]: boolean }, key) => {
			acc[parseInt(key)] = parseInt(key) === index

			return acc
		}, {})

		setAccordionState(newState)
	}

	return (
		<ul className={styles.list}>
			{data.accordions.map((item, i) => {
				return (
					<IconAccordionItem
						data={item}
						handleSetActive={() => handleSetActive(i)}
						isActive={accordionState[i]}
						key={i}
					/>
				)
			})}
		</ul>
	)
}

export default IconAccordion
